import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {

    // Init Swiper
    const heroSwiper = new Swiper('.hero-swiper', {
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });

    // Linear-eased scroll animation (replaces the browser's native easing)
    const animateScrollTo = (targetY, duration = 700) => {
        const startY = window.scrollY || window.pageYOffset;
        const distance = targetY - startY - 96;
        let startTime = null;

        const step = (currentTime) => {
            if (startTime === null) startTime = currentTime;
            const progress = Math.min((currentTime - startTime) / duration, 1); // linear ease
            window.scrollTo(0, startY + distance * progress);
            if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    };

    const scrollToElement = (el) => {
        const top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        animateScrollTo(top);
    };

    // Scroll-down button: linear scroll to the next section after the hero
    const scrollBtn = document.querySelector('.js-hero-scroll');
    if (scrollBtn) {
        scrollBtn.addEventListener('click', () => {
            const hero = document.getElementById('hero');
            const nextSection = hero && hero.nextElementSibling;
            if (nextSection) scrollToElement(nextSection);
        });
    }

    // Hero CTA button: when it points to an on-page anchor, animate the scroll
    // with the same linear ease instead of jumping.
    const heroCta = document.querySelector('.hero-content .btn');
    if (heroCta) {
        const href = heroCta.getAttribute('href') || '';
        const hashIndex = href.indexOf('#');
        if (hashIndex !== -1) {
            const id = href.slice(hashIndex + 1);
            const target = id ? document.getElementById(id) : null;
            if (target) {
                heroCta.addEventListener('click', (e) => {
                    e.preventDefault();
                    scrollToElement(target);
                });
            }
        }
    }

    // Add .scrolled class to header on scroll
    const header = document.querySelector('.site-header');
    if (header) {
        const onScroll = () => {
            header.classList.toggle('scrolled', window.scrollY > 60);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }
});
